import React from 'react'
import "./ReviewComponent.css"
import testimonial1 from "../../Images/testimonial-1.png"
import testimonial2 from "../../Images/testimonial-2.png"
import testimonial3 from "../../Images/testimonial-3.png"
import testimonial4 from "../../Images/testimonial-4.png"
import testimonial5 from "../../Images/testimonial-5.png"
import testimonial6 from "../../Images/testimonial-6.png"
import testimonial7 from "../../Images/testimonial-7.png"
import testimonial8 from "../../Images/testimonial-8.png"
import testimonial9 from "../../Images/testimonial-9.png"
import { FaStar } from 'react-icons/fa';


const ReViewComponent2 = () => {
  return (
    <section className="troo-da-review-section" id="troo-da-review-section">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="troo-tile">
            <span>Our owesome team</span>
            <h2>What they are talking<br/>
              about our services</h2>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-4">
            <div className="review-ss">
              <div className="review-star">
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial1} alt='testimonial1' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Sara Smith</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="review-ss elisha-col">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial2} alt='testimonial2' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Elisha headson</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="review-ss">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial3} alt='testimonial3' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Naomi Diaz</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="review-ss">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial4} alt='testimonial4' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Yasmine Fritz </h5>
                <p>Client</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="review-ss elisha-col">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial5} alt='testimonial5' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Mattie Cardenas</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="review-ss">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial6} alt='testimonial6' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Miah Ortiz</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="review-ss">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial7} alt='testimonial7' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Chaya Miranda</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="review-ss elisha-col">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial8} alt='testimonial8' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Thalia Adams</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="review-ss">
              <div className="review-star">
               <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>It is a long established fact that it is also reader jadge we arewill be distracted by owen the
                readable and content of a page.</p>
              <div className="client-img">
                <img src={testimonial9} alt='testimonial9' />
                <div className="cod-img">“</div>
              </div>
              <div className="client-del">
                <h5>Sofia Hancock</h5>
                <p>Client</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  )
}

export default ReViewComponent2